"use client";

import { useCallback } from "react";
import ReactFlow, {
  Background,
  Controls,
  useNodesState,
  useEdgesState,
  addEdge,
} from "reactflow";
import "reactflow/dist/style.css";

export default function KenyaWorkflow() {
  const initialNodes = [
    {
      id: "1",
      data: { label: "Visa étudiant" },
      position: { x: 250, y: 200 },
      style: { background: "#6366f1", color: "#fff", borderRadius: 12, padding: 10 },
    },
    {
      id: "2",
      data: { label: "Logement étudiant" },
      position: { x: 100, y: 300 },
      style: { background: "#0a6e4dff", color: "#fff", borderRadius: 12, padding: 10 },
    },
    {
      id: "3",
      data: { label: "Inscription universitaire" },
      position: { x: 400, y: 300 },
      style: { background: "#6d2379ff", color: "#fff", borderRadius: 12, padding: 10 },
    },
    {
      id: "4",
      type: "output",
      data: { label: "Avenir prometteur au Kenya" },
      position: { x: 250, y: 400 },
      style: { background: "#1d2942ff", color: "#fff", borderRadius: 12, padding: 10 },
    },
    {
      id: "5",
      type: "input",
      data: { label: "My student process" },
      position: { x: 250, y: 0 },
      style: { background: "#8d7706ff", color: "#fff", borderRadius: 12, padding: 10 },
    },
    {
      id: "6",
      data: { label: "Info guide premium" },
      position: { x: 250, y: 100 },
      style: { background: "#ae2a7bff", color: "#fff", borderRadius: 12, padding: 10 },
    }
    ,
    {
      id: "7",
      type: "output",
      data: { label: "Universités" },
      position: { x: 430, y: 140 },
      style: { background: "#186c2cff", color: "#fff", borderRadius: 12, padding: 10 },
    }
  ];

  const initialEdges = [
    { id: "e1-2", source: "1", target: "2", animated: true, label: "Étape 2" },
    { id: "e1-3", source: "1", target: "3", animated: true, label: "Étape 3" },
    { id: "e2-4", source: "2", target: "4", animated: true, label: "Suite" },
    { id: "e3-4", source: "3", target: "4", animated: true, label: "Suite" },
    { id: "e5-6", source: "5", target: "6", animated: true, label: "" },
    { id: "e6-1", source: "6", target: "1", animated: true, label: "" },
    { id: "e5-7", source: "5", target: "7", animated: true, label: "" },
  ];

  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge({ ...params, animated: true }, eds)),
    [setEdges]
  );

  return (
    <div className="h-screen w-full dark:bg-gray-900 mt-10 bg-gray-50">
      <h1 className="text-2xl md:text-3xl font-bold text-center pt-6 pb-2">
        Plan de travail 
      </h1>
      <p className="text-center text-gray-600 max-w-2xl dark:text-gray-300 mx-auto px-4">
        
MKSP vous guide pas à pas dans votre parcours étudiant au Kenya. Explorer les universités gratuitement et Créez un compte pour explorer le processus et passez en premium pour accéder aux informations exclusives.
      </p>

      <div className="h-[80vh] w-full mt-6">
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          fitView
        >
          
          <Controls />
          <Background variant="dots" gap={12} size={1} />
        </ReactFlow>
      </div>
    </div>
  );
}
